import { NumericInputDS, Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo } from "react";

export const LimitBalanceOptions = (props: {
  lowerLimit: number | "";
  setLowerLimit: (lowerLimit: number | "") => void;
  upperLimit: number | "";
  setUpperLimit: (upperLimit: number | "") => void;
  displayError: boolean;
}) => {
  const { t } = useTranslation();
  const { lowerLimit, upperLimit, displayError, setLowerLimit, setUpperLimit } =
    props;

  const isLowerLimitValid = useMemo(() => {
    return lowerLimit < upperLimit;
  }, [lowerLimit, upperLimit]);

  const getLowerLimitError = useCallback(() => {
    if (displayError) {
      if (!lowerLimit) {
        return t("sepaDirectDebit.limitBalanceOptions.lowerLimit.error");
      }
      if (!isLowerLimitValid) {
        return t("sepaDirectDebit.limitBalanceOptions.limits.error");
      }
    }
    return undefined;
  }, [displayError, lowerLimit, isLowerLimitValid, t]);

  const getUpperLimitError = useCallback(() => {
    if (displayError) {
      if (!upperLimit) {
        return t("sepaDirectDebit.limitBalanceOptions.upperLimit.error");
      }
      if (!isLowerLimitValid) {
        return t("sepaDirectDebit.limitBalanceOptions.limits.error");
      }
    }
    return undefined;
  }, [displayError, upperLimit, isLowerLimitValid, t]);

  return (
    <>
      <Spacer y={1.5} />
      <NumericInputDS
        label={t("sepaDirectDebit.limitBalanceOptions.lowerLimit")}
        placeholder={t(
          "sepaDirectDebit.limitBalanceOptions.lowerLimit.placeholder",
        )}
        update={(value) => setLowerLimit(value !== "" ? value : "")}
        value={lowerLimit}
        isMandatory
        floatNumber
        error={getLowerLimitError()}
      />
      <NumericInputDS
        label={t("sepaDirectDebit.limitBalanceOptions.upperLimit")}
        placeholder={t(
          "sepaDirectDebit.limitBalanceOptions.upperLimit.placeholder",
        )}
        update={(value) => setUpperLimit(value !== "" ? value : "")}
        value={upperLimit}
        isMandatory
        floatNumber
        error={getUpperLimitError()}
      />
    </>
  );
};
